import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, Plus, Trash2, Copy, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function Developers() {
  const [keys, setKeys] = useState([]);
  const [usage, setUsage] = useState({ rows: [], total_credits: 0, count: 0 });
  const [newKey, setNewKey] = useState(null);

  const load = () => {
    api.get("/keys").then((r) => setKeys(r.data)).catch(() => {});
    api.get("/usage").then((r) => setUsage(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    const { data } = await api.post("/keys", { name: "Clé " + new Date().toLocaleDateString("fr-FR") });
    setNewKey(data.key); toast.success("Clé créée — copiez-la, elle ne sera plus affichée"); load();
  };
  const del = async (id) => { await api.delete(`/keys/${id}`); toast.success("Clé supprimée"); load(); };
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copié"); };

  return (
    <div className="space-y-6" data-testid="developers-page">
      <div className="flex items-end justify-between">
        <div><p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-400">Développeurs</p>
          <h1 className="mt-1 font-display text-3xl font-bold tracking-tight">Clés API & usage</h1></div>
        <Button onClick={create} data-testid="create-key-btn" className="rounded-full bg-gold-500 text-black hover:bg-gold-400"><Plus className="mr-1 h-4 w-4" />Nouvelle clé</Button>
      </div>

      {newKey && (
        <div className="flex items-center gap-3 rounded-xl border border-gold-500/40 bg-gold-500/10 p-4" data-testid="new-key-banner">
          <code className="flex-1 truncate font-mono text-sm">{newKey}</code>
          <button onClick={() => copy(newKey)} className="text-gold-400"><Copy className="h-4 w-4" /></button>
        </div>
      )}

      <div className="rounded-2xl border border-border bg-card">
        {keys.length === 0 && <p className="p-6 text-sm text-muted-foreground">Aucune clé. Créez-en une pour appeler l'API.</p>}
        {keys.map((k) => (
          <div key={k.id} className="flex items-center justify-between border-b border-border p-4 last:border-0" data-testid={`key-${k.id}`}>
            <div className="flex items-center gap-3"><KeyRound className="h-4 w-4 text-gold-400" />
              <div><p className="text-sm font-medium">{k.name}</p><code className="font-mono text-xs text-muted-foreground">{k.key_masked}</code></div></div>
            <button onClick={() => del(k.id)} data-testid={`delete-key-${k.id}`} className="text-muted-foreground hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2"><Activity className="h-4 w-4 text-gold-400" /><h3 className="font-display font-semibold">Console d'usage</h3></div>
          <span className="text-sm text-muted-foreground">{usage.count} appels · <span className="font-mono text-gold-400">{usage.total_credits} crédits</span></span>
        </div>
        <div className="space-y-1.5 max-h-72 overflow-y-auto">
          {usage.rows.map((r, i) => (
            <div key={i} className="flex items-center justify-between text-sm" data-testid={`usage-${i}`}>
              <span className="text-muted-foreground">{r.model} <span className="rounded bg-secondary px-1.5 py-0.5 text-xs">{r.kind}</span></span>
              <span className="font-mono">−{r.credits} cr · {new Date(r.ts).toLocaleString("fr-FR")}</span>
            </div>
          ))}
          {usage.rows.length === 0 && <p className="text-sm text-muted-foreground">Aucun appel pour l'instant.</p>}
        </div>
      </div>
    </div>
  );
}
